import advertisers from '../../api/offers'

export default {
  state: {
    advertisers: [],
    sflAdvertisers: [],
    sflAdvertisersManagers: [],
    multiplySelectAdvertisers: []
  },
  namespaced: true,
  mutations: {
    async saveAdvertisers(state, advertisers) {
      state.advertisers = advertisers
    },
    async saveSflAdvertisers(state, sflAdvertisers) {
      state.sflAdvertisers = sflAdvertisers
    },
    async saveSflAdvertisersManagers(state, sflAdvertisersManagers) {
      state.sflAdvertisersManagers = sflAdvertisersManagers
    },
    saveMultiplySelectAdvertisers(state, adverisers) {
      state.multiplySelectAdvertisers.length = 0
      state.multiplySelectAdvertisers.push(adverisers)
    }
  },
  actions: {
    async saveAdvertisersStore({commit}) {
      commit('saveAdvertisers', await advertisers.advertisers())
    },
    async saveSflAdvertisersStore({commit}, data) {
      commit('saveSflAdvertisers', await advertisers.sflAdvertisers(data))
    },
    async saveSflAdvertisersManagersStore({commit}) {
      commit('saveSflAdvertisersManagers', await advertisers.sflAdvertisersManagers())
    },


  },
  getters: {
    getAdvertisers: state => state.advertisers,
    getSflAdvertisers: state => state.sflAdvertisers,
    getSflAdvertisersManagers: state => state.sflAdvertisersManagers,
    getMultiplySelectAdvertisers: state => state.multiplySelectAdvertisers
  },

}
